import React from 'react'
import cardsUser from '../components/assets/cards-user-money.png'
import cardsSwap from '../components/assets/cards-user-swap.png'
import cardsGroup from '../components/assets/cards-user-group.png'


function Cards() {
  return (
    <div className='w-full py-[10rem] px-4 bg-white'>
        <div className='max-w-[1240px] mx-auto grid md:grid-cols-3 gap-8'>
            <div className='w-full shadow-xl flex flex-col p-4 my-4 rounded-lg hover:scale-105 duration-300'>
            <img className='w-20 mx-auto mt-[-3] bg-transparent' src={cardsUser} alt="/cardUser"/>
            <h2 className='text-2xl font-bold text-center py-8'>Single User</h2>
            <p className='text-center text-4xl font-bold'>$149</p>
            <div className='text-center font-medium '>
                <p className='py-2 border-b mx-8'>500 GB Storage</p>
                <p className='py-2 border-b mx-8'>1 Granted User</p>
                <p className='py-2 border-b mx-8'>Send up to 2 GB </p>
            </div>
            <button className="bg-[#00fd9a] w-200px rounded-md font-medium my-6 mx-auto px-6 py-3">Start Trial!</button>
            </div>

            <div className='w-full shadow-xl flex flex-col p-4 md:my-8 rounded-lg hover:scale-105 duration-300'>
            <img className='w-20 mx-auto mt-[-3] bg-transparent' src={cardsSwap} alt="/cardUser"/>
            <h2 className='text-2xl font-bold text-center py-8'>Partnership</h2>
            <p className='text-center text-4xl font-bold'>$199</p>
            <div className='text-center font-medium'>
                <p className='py-2 border-b mx-8'>1 GB Storage</p>
                <p className='py-2 border-b mx-8'>3 Granted User</p>
                <p className='py-2 border-b mx-8'>Send up to 10 GB</p>
            </div>
            <button className="bg-[#00fd9a] w-200px rounded-md font-medium my-6 mx-auto px-6 py-3">Start Trial!</button>
            </div>

            <div className='w-full shadow-xl flex flex-col p-4 md:my-8 rounded-lg hover:scale-105 duration-300'>
            <img className='w-20 mx-auto mt-[-3] bg-transparent' src={cardsGroup} alt="/cardUser"/>
            <h2 className='text-2xl font-bold text-center py-8'>Group User</h2>
            <p className='text-center text-4xl font-bold'>$299</p>
            <div className='text-center font-medium'>
                <p className='py-2 border-b mx-8'>500 GB Storage</p>
                <p className='py-2 border-b mx-8'>1 Granted User</p>
                <p className='py-2 border-b mx-8'>Send up to 20 GB</p>
            </div>
            <button className="bg-[#00fd9a] w-200px rounded-md font-medium my-6 mx-auto px-6 py-3">Start Trial!</button>
            </div>
            </div>
    </div>
  )
} 

export default Cards